(function () {
/*
 * -----------------------------------------------------------------------------
 * ANNOUNCEMENT BAR
 * -----------------------------------------------------------------------------
 * @version 0.0.3
 * @kind component
 * @overview Simple rotating announcments.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
 * @param [data-speed=5000] {String}
 * -----------------------------------------------------------------------------
*/ class $9d10de050101344a$var$AnnouncementBar extends HTMLElement {
    constructor(){
        super();
        this.slides = this.childNodes;
        if (this.slides.length < 2) return;
        this.current = 0;
        this.speed = this.dataset.speed ? Number(this.dataset.speed) : 5000;
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.play();
    }
    rotate() {
        this.slides[this.current].hidden = true;
        this.current++;
        if (this.current >= this.slides.length) this.current = 0;
        this.slides[this.current].hidden = false;
    }
    play() {
        this.interval = setInterval(this.rotate.bind(this), this.speed);
        this.removeEventListener("focusout", this.play);
        this.addEventListener("focusin", this.pause);
    }
    pause() {
        clearInterval(this.interval);
        this.removeEventListener("focusin", this.pause);
        this.addEventListener("focusout", this.play);
    }
}
if (customElements.get("announcement-bar") === undefined) customElements.define("announcement-bar", $9d10de050101344a$var$AnnouncementBar);



})();
